<template>
  <div>
    <!--搜索栏-->
    <searchBar
      :search-form="searchForm"
      name
      status
      mobile
      @handleSearch="getData"
      btn-add
      @handleAdd="handleAdd"
    ></searchBar>

    <!--表格-->
    <el-table :data="tableData" border>
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="60"
      ></el-table-column>
      <el-table-column label="头像" align="center" width="130">
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 120px;"
            :src="serverUrl + scope.row.avatar"
            :preview-src-list="getImgPreviewList(scope.row.avatar)"
          ></el-image>
        </template>
      </el-table-column>

      <el-table-column
        v-for="(item, index) in tableHeader"
        :key="index"
        :label="item"
        :prop="index"
        align="center"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="240">
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.row)" type="text" size="mini">
            编辑
          </el-button>
          <el-button
            @click="handleEnabled(scope.row)"
            type="text"
            :style="{ color: scope.row.status === 1 ? 'red' : '' }"
            size="mini"
          >
            {{ scope.row.status === 1 ? "禁用" : "启用" }}
          </el-button>
          <el-button
            @click="handleDelete(scope.row)"
            type="text"
            style="color:red"
            size="mini"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="block">
      <el-pagination
        class="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[4, 10, 20, 30]"
        :page-size="size"
        layout=" prev, pager, next, jumper, sizes"
        :total="totalElements"
      ></el-pagination>
    </div>

    <!--新增Dialog-->
    <el-dialog
      title="添加社区人员"
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="100px"
        label-suffix="："
        label-position="right"
        :status-icon="true"
        :hide-required-asterisk="false"
      >
        <el-form-item label="用户名" prop="username" label-width="100px">
          <el-input
            v-model="form.username"
            size="medium"
            :disabled="!!form.uid"
            placeholder="用户名"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="密码"
          v-if="!this.form.uid"
          prop="password"
          label-width="100px"
        >
          <el-input
            v-model="form.password"
            size="medium"
            show-password
            placeholder="密码"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="确认密码"
          v-if="!this.form.uid"
          prop="confirmPwd"
          label-width="100px"
          style="text-align: left;"
        >
          <el-input
            v-model="form.confirmPwd"
            show-password
            size="medium"
            placeholder="确认密码"
            @blur="testPwd"
          ></el-input>
          <span style="color:#F56C6C;font-size:12px;">
            {{ passwordCheckValidate.errorText }}
          </span>
        </el-form-item>
        <el-form-item label="姓名" prop="name" label-width="100px">
          <el-input
            v-model="form.name"
            size="medium"
            placeholder="姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gender" label-width="100px">
          <el-select
            v-model="form.gender"
            style="width: 100%;"
            placeholder="请选择"
          >
            <el-option
              v-for="item in [
                { label: '男', value: 1 },
                { label: '女', value: 2 },
              ]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出生日期" prop="birthday" label-width="100px">
          <el-date-picker
            style="width: 100%;"
            v-model="form.birthday"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择出生日期"
          ></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="身份证号" prop="idCard" label-width="100px">
          <el-input
            v-model="form.idCard"
            maxlength="18"
            size="medium"
            placeholder="身份证号"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="手机号" prop="mobile" label-width="100px">
          <el-input
            v-model="form.mobile"
            size="medium"
            type="num"
            maxlength="11"
            placeholder="手机号"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="学历" prop="education" label-width="100px">
          <el-select
            v-model="form.education"
            style="width: 100%;"
            placeholder="请选择"
          >
            <el-option
              v-for="item in optionEducation"
              :key="item.uid"
              :label="item.name"
              :value="item.uid"
            >
            </el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="简介" label-width="100px">
          <el-input
            type="textarea"
            autosize
            placeholder="描述内容"
            v-model="form.introduction"
          ></el-input>
        </el-form-item>

        <el-form-item label="备注" label-width="100px">
          <el-input
            type="textarea"
            autosize
            placeholder="描述内容"
            v-model="form.comment"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item
          label="查看权限"
          style="text-align: left"
          label-width="100px"
        >
          <el-radio v-model="form.checkMessage" :label="true"
            >可查看留言
          </el-radio>
          <el-radio v-model="form.checkMessage" :label="false"
            >不可查看留言
          </el-radio>
        </el-form-item> -->

        <el-form-item
          label="头像"
          style="text-align: left"
          prop="avatar"
          label-width="100px"
        >
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :before-upload="overwriteDefault"
          >
            <img
              v-if="form.avatar"
              :src="serverUrl + form.avatar"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <p>点击上传</p>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { downloadFile } from "@/assets/http/utils"
import Axios from "axios"
import apiUrl from "@/assets/http/apiUrl"
import { resetObject } from "@/utils"
export default {
  name: "communityMemberInfo",
  data() {
    let Self = this

    // 表单验证
    let validateMobile = (rule, value, callback) => {
      if (/^1[3456789]\d{9}$/.test(value)) {
        this.$refs.form.validateField("checkPass")
        callback()
      } else {
        callback(new Error("手机号验证失败"))
      }
    }
    let validateIdCard = (rule, value, callback) => {
      if (
        /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          value
        )
      ) {
        this.$refs.form.validateField("checkPass")
        callback()
      } else {
        callback(new Error("身份证号验证失败"))
      }
    }
    let validateAvatar = (rule, value, callback) => {
      if (Self.form.avatar !== "") {
        this.$refs.form.validateField("checkPass")
        callback()
      } else {
        callback(new Error("请上传头像"))
      }
    }

    return {
      // 页面初始数据
      totalElements: 10,
      totalPages: 1,
      size: 4,
      page: 1,

      serverUrl: apiUrl.ServerUrl,

      // 搜索栏初始化
      searchForm: {
        name: "",
        gender: "",
        idCard: "",
        mobile: "",
        family: "",
        street: "",
        education: "",
      },

      // 表头初始化
      tableHeader: {
        username: "用户名",
        name: "名称",
        genderName: "性别",
        birthday: "出生日期",
        mobile: "手机号",
        statusName: "状态",
      },

      // 表格数据
      tableData: [],

      // dialog可见性
      dialogFormVisible: false,
      dialogUploadVisible: false,

      // 上传文件列表
      file: "",

      // 新增表单
      form: {
        uid: "",
        username: "",
        password: "",
        confirmPwd: "",
        name: "",
        gender: "",
        birthday: "",
        // idCard: "",
        mobile: "",
        // occupation: "",
        // education: "",
        introduction: "",
        comment: "",
        // checkMessage: true,
        avatar: "",
      },

      // 表单验证规则
      rules: {
        name: {
          required: true,
          message: "请输入名称",
          trigger: "blur",
        },
        username: {
          required: true,
          message: "请输入用户名",
          trigger: "blur",
        },
        password: {
          required: true,
          message: "请输入密码",
          trigger: "blur",
        },
        confirmPwd: {
          required: true,
          // message: "两次密码不一致",
          // trigger: "blur",
        },
        introduction: {
          required: true,
          message: "请输入介绍",
          trigger: "blur",
        },
        comment: {
          required: true,
          message: "请输入备注",
          trigger: "blur",
        },
        // idCard: {
        //   required: true,

        //   validator: validateIdCard,
        //   trigger: "blur",
        // },
        mobile: {
          required: true,

          validator: validateMobile,
          trigger: "blur",
        },
        gender: {
          required: true,
          message: "请选择性别",
          trigger: "blur",
        },
        family: {
          required: true,
          message: "请选择所属家庭",
          trigger: "change",
        },
        // occupation: {
        //   required: true,
        //   message: "请选择工作类型",
        //   trigger: "change",
        // },
        // education: {
        //   required: true,
        //   message: "请选择学历",
        //   trigger: "change",
        // },
        birthday: {
          required: true,
          message: "请选择出生日期",
          trigger: "change",
        },
        avatar: {
          required: true,
          validator: validateAvatar,
          trigger: "blur",
        },
      },

      // 选择器数据
      optionGroup: [
        {
          name: "全部",
          uid: "",
        },
      ],
      optionStreet: [
        {
          name: "全部",
          uid: "",
        },
      ],
      optionFamily: [
        {
          name: "全部",
          uid: "",
        },
      ],
      optionEducation: [],
      optionOccupation: [],

      // 头像上传初始化
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      // 维护干部信息
      dynamicValidateForm: {
        domains: [
          {
            value: "",
          },
        ],
        email: "",
      },
    }
  },
  computed: {
    passwordCheckValidate: function() {
      var errorText
      if (this.form.confirmPwd !== this.form.password) {
        errorText = "两次密码不一致"
      } else {
        errorText = ""
      }

      // if(!this.passwordFlag) {
      //     errorText = ''
      //     this.passwordFlag = true
      // }
      return {
        errorText,
      }
    },
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!")
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields()
    // },
    removeDomain(item) {
      var index = this.dynamicValidateForm.domains.indexOf(item)
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1)
      }
    },
    addDomain() {
      this.dynamicValidateForm.domains.push({
        value: "",
        key: Date.now(),
      })
    },
    getImgPreviewList(url) {
      let arr = new Array(this.serverUrl + url)
      return arr
    },

    /*请求数据
     * */
    getData() {
      this.request({
        url: "/manager/communityMember/getMemberPage",
        method: "get",
        params: {
          page: this.page,
          size: this.size,

          name: this.searchForm.name,
          idCard: this.searchForm.idCard,
          mobile: this.searchForm.mobile,
          status: this.searchForm.status,
        },
      })
        .then(res => {
          this.size = res.data.data.size
          this.page = res.data.data.page
          this.totalElements = Number(res.data.data.totalElements)
          this.totalElements = Number(res.data.data.totalElements)
          this.totalPages = res.data.data.totalPages

          this.tableData = res.data.data.content
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*获取学历
     * */
    getEducation() {
      this.request({
        url: "/manager/commonDict/getListByKey",
        method: "get",
        params: {
          key: "education",
        },
      })
        .then(res => {
          this.optionEducation = res.data.data
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*更改单页数据数量
     * */
    handleSizeChange(size) {
      this.size = size
      this.getData()
    },

    /*页码跳转
     * */
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },

    /*启用/禁用
     * */
    handleEnabled(rowData) {
      let status = rowData.status === 1 ? 2 : 1
      this.request({
        url: "/manager/communityMember/updateStatus",
        data: {
          uid: rowData.uid,
          status: status,
        },
        method: "post",
      })
        .then(res => {
          this.$message.success("操作成功")
          this.getData()
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*编辑
     * */
    handleEdit(rowData) {
      this.form = {
        ...rowData,
      }
      this.dialogFormVisible = true
    },

    /*添加商户前的处理
     * 需要将options中的'全部'一项给去掉
     * 因为是必填项*/
    handleAdd() {
      this.optionGroup.shift()
      this.dialogFormVisible = true
    },

    /*删除
     * */
    handleDelete(rowData) {
      this.$confirm("确认删除?")
        .then(() => {
          this.request({
            url: "/manager/communityMember/deleteMember",
            params: {
              uid: rowData.uid,
            },
            method: "DELETE",
          })
            .then(res => {
              this.$message.success("删除成功")
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch()
    },
    // 失去焦点，检测两次密码是否一致
    testPwd(e) {
      console.log(this.form.password, this.form.confirmPwd)
      // if(this.form.password != this.form.confirmPwd){

      // }
    },

    /*dialog提交
     * */
    dialogConfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.request({
            url: "/manager/communityMember/addOrUpdateMembers",
            data: {
              uid: this.form.uid,

              name: this.form.name,
              idCard: this.form.idCard,
              mobile: this.form.mobile,
              gender: this.form.gender,
              avatar: this.form.avatar,
              birthday: this.form.birthday,
              education: this.form.education,
              introduction: this.form.introduction,
              comment: this.form.comment,
              checkMessage: this.form.checkMessage,
              username: this.form.username,
              password: this.form.password,
              confirmPwd: this.form.confirmPwd,
            },
            method: "post",
          })
            .then(res => {
              if (res.data.status === "BAD_REQUEST") {
                this.$message.warning(res.data.message)
                this.dialogFormVisible = true
              }

              this.getData()
              // this.dialogFormVisible = false
              this.dialogCancel()
              // this.form = {
              //   uid: "",
              //   username: "",
              //   password: "",
              //   confirmPwd: "",
              //   name: "",
              //   gender: "",
              //   birthday: "",
              //   idCard: "",
              //   mobile: "",
              //   occupation: "",
              //   education: "",
              //   introduction: "",
              //   comment: "",
              //   checkMessage: true,
              //   avatar: "",
              // }
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        }
      })

      this.optionGroup.unshift({
        name: "全部",
        uid: "",
      })
    },

    /*dialog取消
     * */
    dialogCancel() {
      this.dialogFormVisible = false
      this.$refs.form.resetFields()
      resetObject(this.form)
    },

    /*获取小组
     * */
    getGroup() {
      this.request({
        url: "/manager/group/groupList",
        method: "get",
        params: {
          status: 1,
        },
      })
        .then(res => {
          res.data.data.forEach(item => {
            this.optionGroup.push(item)
          })
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*获取街道
     * */
    getStreet(node, resolve) {
      let nodes
      this.request({
        url:
          node.level === 2
            ? "/manager/family/familyList"
            : "/manager/street/streetList",
        method: "get",
        params: {
          status: 1,

          uid: node.value,
        },
      })
        .then(res => {
          if (!res.data.data) {
            this.$message.warning("此小组无下属信息")
            return
          }
          nodes = res.data.data.map(item => {
            return {
              name: item.name,
              uid: item.uid,
              leaf: node.level === 2,
            }
          })
          resolve(nodes)
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*覆盖默认上传请求
     * */
    overwriteDefault(e) {
      let tmpFile = new FormData()
      tmpFile.append("file", e)
      tmpFile.append("folder", "communityMember")
      // this.file = tmpFile
      Axios.post(apiUrl.server + "/manager/upload/uploadFile", tmpFile)
        .then(res => {
          this.form.avatar = res.data
        })
        .catch(err => {
          this.$message.error("上传失败")
        })
    },

    uploadCancel() {
      this.dialogUploadVisible = false
      this.form = {}
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
  },
  mounted() {
    this.getEducation()
    this.getData()
  },
}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
